import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import React from 'react'

import GameTypeIcon from '../_common/GameTypeIcon'

export const PlayersInfo = ({ gameType, categoryName }) => (
  <Box
    sx={(theme) => ({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: theme.palette.text.tertiary,
      gap: '4px',
    })}
  >
    <GameTypeIcon
      gameType={gameType}
      size="small"
    />
    <Typography
      variant="h6"
      color="text.secondary"
    >
      {categoryName}
    </Typography>
  </Box>
)

export default PlayersInfo
